import React from 'react';
import classnames from 'classnames';

const SecuredCheckout = ({ className }) => (
  <div
    className={classnames('secured-checkout d-flex align-items-center justify-content-center', {
      [className]: className
    })}
  >
    <img
      style={{
        width: '9px',
        position: 'relative',
        top: '-3px'
      }}
      src="/assets/lock.png"
      alt="lock"
    />
    <p className="ml-2 mb-0 font-weight-normal">Secured checkout</p>
  </div>
);

export default SecuredCheckout;



// WEBPACK FOOTER //
// ./src/components/SecuredCheckout/index.js